<template>
    <div>
        <!-- Modal de Vinculo da Tabela -->
        <div class="modal fade" id="vincularTabelaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        {{ !id_operadora ? 'Vinculo Operadora' : 'Tabela' }}
                        {{ item.id_tabela_operadora ? '' : '(Nova)' }}
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row" v-if="!id_operadora && !item.id_tabela_operadora">
                        <div class="col col-12">
                            <az-input
                                sizing="sm"
                                label="Operadora"
                                type="select"
                                optionsMode="aql"
                                optionsData="id_operadora"
                                service="operadoras.index"
                                required
                                :validate="validate"
                                v-model="item.id_operadora" />
                        </div>
                    </div>

                    <div class="alert alert-info" v-else-if="item.id_tabela_operadora && item.operadora">
                        {{ item.operadora.st_operadora }}
                    </div>

                    <div class="row">
                        <div class="col col-12">
                            <az-input 
                                label="Título" 
                                placeholder="Informe o título para tabela na operadora..."
                                :validate="validate"
                                v-model="item.st_titulo" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-12 col-md-3">
                            <az-input 
                                type="date" 
                                label="Início da Vigência" 
                                :validate="validate"
                                required
                                v-model="item.dt_inicio_vigencia" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input 
                                type="date" 
                                label="Término da Vigência" 
                                :validate="validate"
                                v-model="item.dt_termino_vigencia" />
                        </div>
                        <div class="col col-12 col-md-6">
                            <az-input
                                type="select"
                                optionsMode="aql"
                                service="codigo_tabelas.index"
                                optionsData="id_codigo_tabela"
                                label="Código da Tabela"
                                required
                                :validate="validate"
                                v-model="item.id_codigo_tabela" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-12">
                            <az-input
                                type="autocomplete"
                                optionsMode="aql"
                                :optionsSync="false"
                                service="tabela_versaos.index"
                                optionsData="id_tabela_versao"
                                :optionsParm="{ id_operadora: id_operadora }"
                                :optionsReload="true"
                                label="Tabela"
                                required
                                :validate="validate"
                                v-model="item.id_tabela_versao" />
                        </div>
                    </div>

                    <template v-if="!id_plano">
                        <template v-if="item.id_plano || item.id_classe_procedimento || item.id_procedimento">
                            <az-sub-title class="mt-3" title="Escopo" />
                            <div class="row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        type="select"
                                        optionsMode="aql"
                                        :optionsSync="false"
                                        service="planos.index"
                                        :name="'planos.' + item.id_operadora"
                                        optionsData="id_plano"
                                        :optionsParm="{ where: { id_operadora: item.id_operadora } }"
                                        label="Plano"
                                        v-model="item.id_plano" />
                                </div>
                                <div class="col col-12 col-md-4" v-if="tipoTabela == 'PRO'">
                                    <az-input
                                        label="Classificação"
                                        service="classe_procedimentos.index"
                                        type="select"
                                        optionsMode="aql"
                                        :optionsSync="false"
                                        optionsData="id_classe_procedimento"
                                        optionsDisplay="search"
                                        :validate="validate"
                                        :edicao="!item.id_procedimento"
                                        v-model="item.id_classe_procedimento" />
                                </div>
                                <div class="col col-12 col-md-4" v-if="tipoTabela == 'PRO'">
                                    <az-input
                                        label="Procedimento"
                                        :validate="validate"
                                        type="autocomplete"
                                        service="procedimentos.index"
                                        optionsData="id_procedimento"
                                        optionsDisplay="search"
                                        :optionsInitial="item.procedimento ? item.procedimento.search : ''"
                                        :edicao="!item.id_classe_procedimento"
                                        v-model="item.id_procedimento" />
                                </div>
                            </div>
                        </template>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                    </template>
                </div>
                <div class="modal-footer">
                    <az-submit
                        color="outline-danger"
                        @click="remover ()"
                        v-if="item.id_tabela_operadora">
                        Remover
                    </az-submit>
                    <az-audit-log-button model="tabelaOperadora" :id="item.id_tabela_operadora" />
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <az-submit @click="atualizar ()">Atualizar</az-submit>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() { 
        return { 
            item: null, 
            validate: false, 
        };
    }, 

    props: ['id_operadora', 'id_plano', 'id_tabela_versao'],

    components: { 
        AzInput, 
        AzSubmit, 
        FiltroModel, 
        AzAuditLogButton,
    },
    
    computed: { 
        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index'});
            }
            
            return opcoes;
        }
    },

    methods: { 

        editar(item) {
            this.item = { ...item };
            this.validate = false;
            $("#vincularTabelaModal").modal("show");
        },

        remover() {
            this.$util.remover(this, {
                service: "tabela_operadoras",
                dados: this.item,
                modal: "vincularTabelaModal",
                reload: true
            });
        },

        atualizar() {
            this.$util.atualizar(this, {
                service: "tabela_operadoras",
                dados: this.item,
                modal: "vincularTabelaModal",
                reload: true
            });
        },

        load() { 
            this.$emit('refresh');
        },

        incluir(id_tabela_versao = null) {
            this.editar({
                id_tabela_operadora: null,
                id_operadora: this.id_operadora,
                id_codigo_tabela: null,
                id_tabela_versao: id_tabela_versao ? id_tabela_versao : this.id_tabela_versao,
                id_plano: this.id_plano,
                id_classe_procedimento: null,
                id_procedimento: null,
                fl_ativo: true,
                fl_excecao: false,
                st_aplicacao: "PRO",
                filtros: [], 
            });
        },

    },
}
</script>
